module.exports = __webpack_public_path__ + "static/blog36-ab1932ca0166af90462ce21503395bd5.png";